<template>
  <LayoutTelas
    id="tela__Entradas"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <EntradasCadastroForm
      ref="formEntradas"
      :dados="dadosEntradas"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import EntradasCadastroForm from './EntradasCadastroForm.vue'
import EntradasService from '../../../services/entradas.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'EntradasCadastro',
  components: {
    EntradasCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosEntradas: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await EntradasService.gravar(dados)
        this.tratarRespostaMsg(retorno)

        this.$refs.formEntradas.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosEntradas = await EntradasService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-Entradas' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__Entradas {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
